import Vue from 'vue'
import Vuex from 'vuex'
import pathify, { make } from 'vuex-pathify'

const state = {
  productmodal: false,
  currentproductdata: '',
  selectproductmodal: '',
  currentgrouppriceid: '',
  currentgrouppricedata: '',
  customermodal: false,
  currentcustomerdata: '',
  adminmodal: false,
  currentadmindata: '',
  orderdetailmodal: false,
  currentorderid: '',
  orderdetailmode: 0,
  orderproductmodal: false,
  currentcustomerid: '',
  currentorderproduct: '',
  dateorderlistmodal: false,
  currentorderlist: [],
  currentorderlistmode: 0,
  importfilemodal: false,
  importmodel: 0,
  bankmodal: false,
  currentbankdata: ''
}

const mutations = make.mutations(state)

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    pathify.plugin
  ],
  state,
  mutations
})
